<template>
  <div class="cont-main">
    <e-form
      ref="refForm1"
      :config="formConfig"
      :column="formColumn1"
      :data.sync="detailData.formData"
      disabled
    />
    <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
      <div class="table-main">
        <el-link
          v-if="id"
          class="link-total-detail"
          type="warning"
          @click="openPopupVerifyGoodsDetail"
        >
          制造明细
        </el-link>
        <TableSale
          v-if="loaded"
          tableTitle="bom表清单"
          :parent="null"
          :data.sync="detailData.tableSaleData"
          :statusName="detailData.formData.status_str"
        />
      </div>
    </div>

    <div class="flex flex-y-center flex-x-between">
      <div class="m-t-10">
        <e-form
          :config="formConfig"
          :column="formColumn2"
          :data.sync="detailData.formData"
          disabled
        />
      </div>
      <div class="total-main">
        <span v-for="(item, index) in formColumn3" :key="index" class="total-item">
          <span>{{ item.title }}:</span>
          <span class="total-item-price">{{ detailData.formData[item.field] }}</span>
          <span>{{ item.suffix }}</span>
        </span>
      </div>
    </div>

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="id"
    />
  </div>
</template>

<script>
export default {
  components: {
    TableSale: () => import('./table-sale')
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      isDetailPush: false,
      isDetailPrint: false,
      formConfig: {
        width: '277px'
      },
      formConfig4: {
        inline: false,
        width: '100%'
      },
      formColumn1: [
        {
          type: 'date',
          title: '销售日期',
          field: 'bill_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '业务员',
          field: 'saler_name',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '客户',
          field: 'company_id',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '开单公司',
          field: 'saler_company_name',
          placeholder: ' '
        },
        {
          type: 'upload_file',
          title: '附件文档',
          field: 'fu_jian_list',
          isDelete: true
        },
        {
          type: 'text',
          title: '单据备注',
          field: 'bill_remark',
          width: '1108px',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '订单类型',
          field: 'ding_dan_lei_xing',
          placeholder: ' '
        },
        {
          type: 'date',
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '审核人',
          field: 'tong_guo_name',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '审核时间',
          field: 'tong_guo_date',
          placeholder: ' '
        },
        {
          type: 'text',
          title: '订单状态',
          field: 'status_str',
          placeholder: ' '
        }
      ],
      formColumn2: [
        {
          type: 'number',
          title: '税率',
          field: 'bill_tax_rate',
          suffix: '%'
        },
        {
          type: 'number',
          title: '税金',
          field: 'tax_fees_total',
          suffix: '元',
          placeholder: '自动计算'
        }
      ],
      formColumn3: [
        {
          title: '订单销售金额',
          field: 'sales_amount_total',
          suffix: '元'
        },
        {
          title: '订单成本',
          field: 'cost_price_total',
          suffix: '元'
        },
        {
          title: '订单利润',
          field: 'profit_total',
          suffix: '元'
        },
        {
          title: '订单利润率',
          field: 'profit_rate_total',
          suffix: '%'
        }
      ],

      detailData: {
        formData: {
          version: 2,
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 销售日期
          bill_code: '', // 销售单号
          saler_id: '', // 业务员id
          saler_name: '', // 业务员
          commission_rate: '', // 提成比例
          company_name: '', // 客户
          company_id: '', // 客户id
          company_uuid: '', // 客户uuid
          saler_company_name: this.$constant.company_info.company_name, // 开单公司
          fu_jian_list: [], // 附件文档
          bill_remark: '', // 单据备注
          ding_dan_lei_xing: '销售订单', // 订单类型
          jiao_huo_ri_qi: '', // 交货日期
          bill_tax_rate: '', // 税率
          tax_fees_total: '', // 税金
          sales_amount_total: '', // 订单销售金额
          cost_price_total: '', // 订单成本
          profit_total: '', // 订单利润
          profit_rate_total: '', // 订单利润率
          push_money: '', // 提成金额
          status_str: ''
        },
        tableSaleData: [],
        pact_bill: {}
      }, // 详情数据

      isShowPopupVerifyGoodsDetail: false // 制造明细
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 400}px`
      return result
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.loaded = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/detail',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.detailData = this.$util.deepCopy(res.data)
          this.loaded = true
        }
      })
    },
    // 制造明细
    openPopupVerifyGoodsDetail() {
      this.isShowPopupVerifyGoodsDetail = true
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  display: flex;
  flex-direction: column;
  .table-main {
    position: relative;
    border: 1px solid #e8eaec;
    .link-total-detail {
      position: absolute;
      top: 8px;
      left: 85px;
      font-size: 14px;
      font-weight: bold;
      z-index: 99;
    }
    .total-item {
      & ~ .total-item {
        margin-left: 10px;
      }
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }

  .cont-form {
    display: flex;
    margin-top: 10px;
    border: 1px solid #e8eaec;

    .form-title {
      font-size: 14px;
      color: @colorGreen;
      font-weight: bold;
      line-height: 28px;
      padding: 5px 5px 0 5px;
    }
    .form-list {
      padding: 5px;
      flex: 1;
    }
    /deep/ .el-form-item {
      margin-bottom: 5px;
    }
    /deep/ .el-form-item__label {
      line-height: 24px;
    }
    /deep/ .el-form-item__content {
      height: 24px;
      line-height: 24px;
    }
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
    /deep/ .el-input__icon {
      line-height: 24px;
    }
  }

  .total-main {
    height: 48px;
    line-height: 48px;
    font-size: 12px;
    color: #606266;
    .total-item {
      margin-left: 20px;
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }
}
</style>
